import type {
	SnackBlockItemContainerInput,
	SnackBlockItemInput,
	SnackBlocksInput,
} from "@/lib/gql/__generated__/graphql";

import type { DesignSnackBlocksFormModel } from "../type";

type Props = {
	viewModel: DesignSnackBlocksFormModel["ViewModel"];
};

export const viewModelToInput = ({ viewModel }: Props): SnackBlocksInput => {
	const {
		hotelID,
		uuid,

		bgImage,
		logoImage,
		snsSetting,
		blocks,
		isShowOriginalBgImage,
		isShowLanguageSwitcher,
	} = viewModel;

	// snsSettingが設定されているかどうか
	const snsSettingIsSet = snsSetting?.snsIcons.value.some((snsIcon) => snsIcon.selected.value);

	const input: SnackBlocksInput = {
		hotelID,
		uuid,

		bgImage: bgImage?.value,
		blocks: blocks.value.map((block) => {
			return {
				uuid: block.uuid.value,
				title: block.title?.value,
				items: block.items.value
					.filter((item) => "itemUUID" in item)
					.map((item) => {
						return {
							// cli（tsc）でのみエラーが出るので、ts-ignore を追加している
							// eslint-disable-next-line @typescript-eslint/ban-ts-comment
							// @ts-ignore
							itemType: item.itemType.value,
							// cli（tsc）でのみエラーが出るので、ts-ignore を追加している
							// eslint-disable-next-line @typescript-eslint/ban-ts-comment
							// @ts-ignore
							itemUUID: item.itemUUID.value,
						} satisfies SnackBlockItemInput;
					}) satisfies SnackBlockItemInput[],
			} satisfies SnackBlockItemContainerInput;
		}),
		isShowOriginalBgImage: isShowOriginalBgImage?.value,
		isShowLanguageSwitcher: isShowLanguageSwitcher?.value,
		logoImage: logoImage?.value,
		snsSetting: snsSettingIsSet
			? {
					snsColor: snsSetting?.snsColor?.value,
					snsIcons: snsSetting?.snsIcons?.value
						.filter(
							// 選択されているSNSアイコンのみを抽出
							(snsIcon) => snsIcon.selected.value,
						)
						.map((snsIcon) => {
							return {
								snsType: snsIcon.snsType.value,
								url: snsIcon.url?.value ?? "",
							};
						}),
				}
			: undefined,
	} satisfies SnackBlocksInput;

	return input;
};
